export default __webpack_public_path__ + "4481076e86d80c5e2033f6b43ad75dfb.png";